import React from 'react'
import Interest from './Interest'

const Interests = () => {

    return (
        <React.Fragment>
            <div className="block-title">
                <h3>Interests</h3>
            </div>
            <div className="row">

                <Interest category={"Front End"}
                    detail={"HTML, CSS, JavaScript, React, Bootstrap, Material UI, Redux, Webpack, Data Visualization"}
                    logo={"images/service/web_design.png"} />

                <Interest category={"Back End"}
                    detail={"Python, Django, Node (Express), RESTful APIs, Graph QL"}
                    logo={"images/service/backend.png"} />

                <Interest category={"Database"}
                    detail={"MSSQL, MySQL, PostgreSQL, Oracle, MongoDB"}
                    logo={"images/service/database.png"} />

                <Interest category={"Dev OPS"}
                    detail={"Amazon Web Services, Jenkins, Docker"}
                    logo={"images/service/devops.png"} />

            </div>
        </React.Fragment>
    )
}

export default Interests